module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.contact.name) ? _c('div', {
    staticClass: "tjhzs_job_head"
  }, [_c('div', {
    staticClass: "title title-n"
  }, [_vm._v("招聘岗位")]), _vm._v(" "), _c('div', {
    staticClass: "email email-n"
  }, [_c('span', [_vm._v("简历投递邮箱：")]), _vm._v(" "), _c('span', {
    staticClass: "hrEmail hrEmail-n"
  }, [_vm._v(_vm._s(_vm.contact.email) + "(" + _vm._s(_vm.contact.name) + ")")])])]) : _c('div', {
    staticClass: "tjhzs_job_head"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("招聘岗位")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('span', [_vm._v("简历投递邮箱：")]), _vm._v(" "), _c('span', {
    staticClass: "hrEmail"
  }, [_vm._v(_vm._s(_vm.contact.email))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fb7aed46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/job/Jobheader.vue
// module id = 190
// module chunks = 1